import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, switchMap } from "rxjs/operators";
import { KJSData } from "../base-models/kjs-data";
import { ConfigService } from "./config.service";

@Injectable({
    providedIn: 'root'
})
export class KJSDataService {
    constructor(
        protected configService: ConfigService,
        protected httpClient: HttpClient
    ){
    }

    GetByPib(pib: string){
        return this.configService.GetCompanyDataServiceUrlAsync()
            .pipe(switchMap(config => {
                return this.httpClient
                    .post(config + 'api/KJS/SearchPib?pib=' + pib, null)
                        .pipe(map((data: KJSData[]) => {
                            if (data){
                                const items: KJSData[] = data["rows"] ? data["rows"].map(item => {
                                    return (new KJSData().Deserialize(item));
                                }) : [];
                                
                                let tipovi : Array<string> = ['0','1','2','4','5','6','9','10','11'];
                                let itemsFilter : KJSData[];
                                itemsFilter = items.filter(item => {return tipovi.indexOf(item.Tip.trim()) > -1 });
                                if (itemsFilter.length > 0)
                                    return itemsFilter;
                                else
                                    return null;
                            }
                            else 
                                return null;
                        })
                    )
            }))
    }

    GetByMb(mb: string){
        return this.configService.GetCompanyDataServiceUrlAsync()
            .pipe(switchMap(config => {
                return this.httpClient
                    .post(config + 'api/KJS/SearchMb?mb=' + mb , null)
                        .pipe(map((data: KJSData[]) => {
                            if (data){
                                const items: KJSData[] = data["rows"] ? data["rows"].map(item => {
                                    return (new KJSData().Deserialize(item));
                                }) : [];

                                let tipovi : Array<string> = ['0','1','2','4','5','6','9','10','11'];
                                let itemsFilter : KJSData[];
                                itemsFilter = items.filter(item => {return tipovi.indexOf(item.Tip.trim()) > -1 });
                                if (itemsFilter.length > 0)
                                    return itemsFilter;
                                else
                                    return null;
                            }
                            else 
                                return null;
                        }))
            }))
    }

    GetByJBKJS(jbkjs: string){
        return this.configService.GetCompanyDataServiceUrlAsync()
            .pipe(switchMap(config => {
                return this.httpClient
                    .get(config + 'api/KJS/SearchJBKJS?jbkjs=' + jbkjs)
                        .pipe(map((data: KJSData[]) => {
                            const items: KJSData[] = data ? data.map(item => {
                                return (new KJSData().Deserialize(item));
                            }) : [];

                            let tipovi : Array<string> = ['0','1','2','4','5','6','9','10','11'];
                            let itemsFilter : KJSData[];
                            itemsFilter = items.filter(item => {return tipovi.indexOf(item.Tip.trim()) > -1 });
                            if (itemsFilter.length > 0)
                                return itemsFilter;
                            else
                                return null;
                        }))
            }))
    }
}